import React from 'react';
import { IconUIComponentProps, useIconStyle } from './Icon';

export default function ({
  color,
  size,
  style,
  className,
  noFill,
}: IconUIComponentProps) {
  const styles = useIconStyle({ noFill });
  return (
    <svg
      className={[styles.icon, className].join(' ')}
      color={color}
      fontSize={size}
      style={style}
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path fillRule="evenodd" clipRule="evenodd" d="M16.6294 3.626V20.374C16.6294 21.2721 17.3573 22 18.2554 22H20.3744C21.2725 22 22.0004 21.2721 22.0004 20.374V3.626C22.0004 2.72786 21.2725 2 20.3744 2H18.2554C17.3573 2 16.6294 2.72786 16.6294 3.626ZM18.2554 21C17.9095 21 17.6294 20.7199 17.6294 20.374V3.626C17.6294 3.28014 17.9095 3 18.2554 3H20.3744C20.7203 3 21.0004 3.28014 21.0004 3.626V20.374C21.0004 20.7199 20.7203 21 20.3744 21H18.2554ZM9.3145 9.908V20.374C9.3145 21.2721 10.0424 22 10.9405 22H13.0595C13.9576 22 14.6855 21.2721 14.6855 20.374V9.908C14.6855 9.00986 13.9576 8.282 13.0595 8.282H10.9405C10.0424 8.282 9.3145 9.00986 9.3145 9.908ZM10.9405 21C10.5946 21 10.3145 20.7199 10.3145 20.374V9.908C10.3145 9.56214 10.5946 9.282 10.9405 9.282H13.0595C13.4054 9.282 13.6855 9.56214 13.6855 9.908V20.374C13.6855 20.7199 13.4054 21 13.0595 21H10.9405ZM2 20.374V16.189C2 15.2916 2.72813 14.563 3.626 14.563H5.745C6.64287 14.563 7.371 15.2916 7.371 16.189V20.374C7.371 21.2721 6.64314 22 5.745 22H3.626C2.72786 22 2 21.2721 2 20.374ZM3 20.374C3 20.7199 3.28014 21 3.626 21H5.745C6.09086 21 6.371 20.7199 6.371 20.374V16.189C6.371 15.8437 6.09044 15.563 5.745 15.563H3.626C3.28056 15.563 3 15.8437 3 16.189V20.374Z" />
    </svg>
  );
}